import React, { MouseEvent, FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, scrollIntoView } from 'ia-react-core';
import { TableOfContents } from '../../interfaces/TableOfContents';
import { StyledDiv, StyledLink, StyledSafeHtml, StyledT3 } from './Items.styles';
import { ReactComponent as ArrowUpward } from '../../assets/Arrow_upward.svg';
import { Items as itemsInterface } from '../../interfaces/Items';

export interface ItemsProps {
  data: TableOfContents;
  isModalItem?: boolean;
}

const Items: FC<ItemsProps> = ({ data, isModalItem }) => {
  const { t } = useTranslation('TableOfContents');
  const handleClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const target = document.querySelector('#contentTable');
    scrollIntoView(target as HTMLElement);
  }, []);
  const renderContent = (isSubItem: boolean, item: itemsInterface, index: number) => {
    const itemId = item.name.replace(/[0-9.\s]/g, '');

    return (
      <StyledDiv isSubItem={isSubItem} key={index}>
        <StyledT3 id={itemId}>
          {item.fields.title}
        </StyledT3>
        <StyledSafeHtml>{item.fields.body}</StyledSafeHtml>
        {!isModalItem && (
          <StyledLink>
            <Link
              onClick={handleClick}
              RightIcon={ArrowUpward}
              href={`${window.location.pathname}${window.location.search}#${itemId}`}
            >
              {t('contentTable')}
            </Link>
          </StyledLink>
        )}
      </StyledDiv>
    );
  };
  return (
    <>
      {data.items.map((item, index) => (
        <React.Fragment key={index}>
          {renderContent(false, item, index)}
          {item.fields?.items?.map((subItem, subIndex) => renderContent(true, subItem, subIndex))}
        </React.Fragment>
      ))}
    </>
  );
};

export default Items;
